<template>
  <div class="contract">
    <mt-header title="修改联系人" class="reftitle">
      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>
      <mt-button @click="modityfContact" slot="right">保存</mt-button>
    </mt-header>
    <div class="savesigner">
      <mt-field label="联系人姓名" placeholder="请输入联系人姓名" v-model="myContact._name"></mt-field>
      <mt-field label="联系人手机号" placeholder="请输入联系人手机号" v-model="myContact._mobile"></mt-field>
      <mt-field label="联系人邮箱" placeholder="请输入联系人邮箱" type="email" v-model="myContact._mail"></mt-field>
    </div>

  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  export default {
    data () {
      return {
        myContact: {
          _name: "",
          _mobile: "",
          _mail: ""
        },
        _selected: "",
        _id: ""
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      valiateData: function () {
        if (this.myContact._name == "" || typeof(this.myContact._name) == "undefined") {
          Toast("请填写联系人姓名.");
          return false;
        }
        if ( typeof(this.myContact._mobile) == "undefined" ||this.myContact._mobile.trim() == "") {
          Toast("请填写联系人电话.");
          return false;
        }
        if (this.myContact._mobile != "") {
          var mobileReg = /^\d{11}$/;
          if (mobileReg.test(this.myContact._mobile.trim()) === false) {
            Toast("请输入正确的手机号.");
            return false;
          }
        }
        if (this.myContact._mail != "") {
          var emailReg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
          if (emailReg.test(this.myContact._mail.trim()) === false) {
            Toast("请输入正确的邮箱号码.");
            return false;
          }
        }
        return true;
      },
      modityfContact: function () {
        var flag = this.valiateData(); // 验证输入框
        if (!flag) {
          return;
        }
        var _editContacts_url = domain("_editContacts");
        var that = this;
        that.$http.post(
          _editContacts_url,
          {
            name: this.myContact._name,
            mail: this.myContact._mail,
            mobile: this.myContact._mobile,
            id: this._id
          },
          {emulateJSON: true}
          )
          .then(function (response) {
            //接口返回数据
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              history.go(-1); //后退1页
            } else {
              Toast(msg)
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.");
        })
      },
      initParams: function () {
        let params = this.$route.query;
        this.myContact._name = params._name;
        this.myContact._mobile = params._mobile;
        this.myContact._mail = params._mail;
        this._selected = params._selected;
        this._id = params._id;
      }
    },
    components: {},
    mounted: function () {
      this.initParams();
    }
  }
</script>
<style>
  .contract .reftitle {
    background-color: #1f74d8;
  }

  .savesigner .mint-cell-text {
    color: #7d7d7d;
  }
</style>



// WEBPACK FOOTER //
// src/module/my/EditMyContact.vue